import STATUS_CODES from 'constants/statusCodes';
import { getSignInUrl } from 'helpers/externalRoutes';
import buildUser from 'helpers/user/buildUser';
import { clearUser, setLoggedUserFields } from 'store/slices/loggedUsers/loggedUserSlice';
import { withCookiesRestClient } from 'helpers/restclient';

const handleRefreshJWTError = ({ dispatch, statusCode }) => {
	const thereIsAServerError =
		statusCode === STATUS_CODES.INTERNAL_SERVER_ERROR || statusCode === STATUS_CODES.SERVICE_UNAVAILABLE;
	if (!thereIsAServerError) {
		dispatch && dispatch(clearUser());
		const signInRedirection = getSignInUrl(window?.location?.href);
		window.location.assign(signInRedirection);
	}
};

export const refreshTokenClientSide = async ({ dispatch }) => {
	try {
		// here we are not using a service because it will cause a circular dependency
		const res = await withCookiesRestClient.post('/api/users/sessions/refresh', {});
		if (res.status == STATUS_CODES.OK) {
			const access_token = res.data.access_token;
			const user = buildUser(access_token);
			dispatch && dispatch(setLoggedUserFields({ loggedUser: user }));
			return user;
		} else {
			handleRefreshJWTError({ dispatch, statusCode: res.status });
		}
	} catch (error) {
		// no connection errors comes here with status 500 error check it please
		handleRefreshJWTError({ dispatch, statusCode: error?.status });
	}
};
